module.exports = [
    { value: 'League', label: 'League', status: 1 },
    { value: 'Birthday Party', label: 'Birthday Party', status: 0 },
    { value: 'Tournament', label: 'Tournament', status: 1 },
    { value: 'Olympics', label: 'Olympics', status: 0 },
    { value: 'Online Meeting', label: 'Online Meeting', status: 1 },
    { value: 'Other', label: 'Other', status: 1 },
].sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by 'label'
